import React from "react";
import "./Footer.css";
import Analytics from "./Analytics";

function Footer() {
  const footerYear = new Date().getFullYear();

  return (
    <>
      {/* <div className="links-container">
        <div className="links-wrap">
          <p className="links-head">
            <span>Quick Links</span>
          </p>
          <div className="link-row">
            <div className="link-box box1">
              <img
                src="images/Home/Acc_GT_Dimensional_RGB.png"
                alt="AccentureIcon"
                className="accenture-icon"
              />
              <p className="follow-site">Follow our site</p>
            </div>
          </div>
          <div className="link-row row2">
            <div className="link-box last-two-links">
              <a
                href="https://mylearning.accenture.com/mylearningui/learner/home"
                target="_blank"
              >
                myLearning{" "}
                <img
                  src="images/Home/popup-latest.png"
                  alt="PopupIcon"
                  className="links-icon"
                />
              </a>
            </div>
          </div>
          <div className="link-row">
            <div className="link-box last-two-links">
              <a href="https://atci.lkm.accenture.com/newhome" target="_blank">
                L&TT{" "}
                <img
                  src="images/Home/popup-latest.png"
                  alt="PopupIcon"
                  className="links-icon"
                />
              </a>
            </div>
          </div>
        </div>
      </div> */}
      <div className="footer_container">
        <p>
          &copy; {footerYear} Accenture. All Rights Reserved. Accenture
          Confidential. For internal use only. Powered by Learning Experiences - L&TT, ATCI.
          <Analytics />
        </p>
      </div>
    </>
  );
}

export default Footer;
